export class AccountingComponentKey {
  static readonly ACCOUNTING_SHELL_MENU = 'accounting/component/accounting-shell-menu';
  static readonly ACCOUNTING_LIST = 'accounting/component/accounting-list';
  static readonly ACCOUNTING_DETAIL = 'accounting/component/accounting-detail';
}
